var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Container",
    [
      _c("Title", { attrs: { strong: "", bold: "" } }, [
        _vm._v(" " + _vm._s(_vm.donationPeriod) + " "),
      ]),
      _c(
        "Form",
        [
          _c(
            "FormCard",
            [
              _c("BreadCrumb", { attrs: { items: _vm.breadCrumbitems } }),
              _c("FormHeading", [
                _vm._v(" " + _vm._s(_vm.steps.DONATION_CONFIRM) + " "),
              ]),
              _c(
                "FormRow",
                [_c("PreviewSectionTitle", [_vm._v("捐款資訊")])],
                1
              ),
              [
                _c(
                  "FormRow",
                  _vm._l(_vm.formattedDonationInfo, function (item, index) {
                    return _c("PreviewField", {
                      key: index,
                      attrs: { name: item.name, value: item.value },
                    })
                  }),
                  1
                ),
              ],
              _c(
                "FormRow",
                [_c("PreviewSectionTitle", [_vm._v("捐款人資訊")])],
                1
              ),
              _vm.isAnonymous
                ? [
                    [
                      _c(
                        "FormRow",
                        _vm._l(_vm.anonymousFields, function (item, index) {
                          return _c("PreviewField", {
                            key: index,
                            attrs: { name: item.name, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                  ]
                : !_vm.isAnonymous && !_vm.isGroup
                ? [
                    _c(
                      "FormRow",
                      _vm._l(_vm.singleFields, function (item, index) {
                        return _c("PreviewField", {
                          key: index,
                          attrs: { name: item.name, value: item.value },
                        })
                      }),
                      1
                    ),
                  ]
                : !_vm.isAnonymous && _vm.isGroup
                ? [
                    _c(
                      "FormRow",
                      _vm._l(_vm.groupFields, function (item, index) {
                        return _c("PreviewField", {
                          key: index,
                          attrs: { name: item.name, value: item.value },
                        })
                      }),
                      1
                    ),
                  ]
                : _vm._e(),
              !_vm.isAnonymous
                ? [
                    _c(
                      "FormRow",
                      [_c("PreviewSectionTitle", [_vm._v("收據資訊")])],
                      1
                    ),
                    [
                      _c(
                        "FormRow",
                        _vm._l(_vm.receiptFields, function (item, index) {
                          return _c("PreviewField", {
                            key: index,
                            attrs: { name: item.name, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                  ]
                : _vm._e(),
              !_vm.isAnonymous
                ? [
                    _c(
                      "FormRow",
                      [_c("PreviewSectionTitle", [_vm._v("其他")])],
                      1
                    ),
                    [
                      _c(
                        "FormRow",
                        _vm._l(_vm.otherFields, function (item, index) {
                          return _c("PreviewField", {
                            key: index,
                            attrs: { name: item.name, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                  ]
                : _vm._e(),
              _c("br"),
              _c("br"),
              _c(
                "Align",
                { attrs: { center: "" } },
                [
                  _c(
                    "Button",
                    {
                      attrs: { back: "" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.back.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v(" 上一步 ")]
                  ),
                  _c(
                    "Button",
                    {
                      nativeOn: {
                        click: function ($event) {
                          return _vm.submit.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v(" 確認 ")]
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }